import axios from 'axios';

import { headers, STOCK_JOURNAL } from '../../config';

export function getIdempotentKey() {
    return axios.get(`${STOCK_JOURNAL}/idempotent-key`, { headers: headers() });
}

export function createStockJournal(data, requestId) {
    return axios.post(`${STOCK_JOURNAL}/stock-journal`, data, { headers: {...headers(), "X-Request-ID": requestId} })
}

export function updateStockJournal(data) {
    return axios.put(`${STOCK_JOURNAL}/stock-journal/${data.id}`, data, { headers: headers() })
}

export function getStockJournalByNumber(query) {
    return axios.get(`${STOCK_JOURNAL}/stock-journal`, { headers: headers(), params: query })
}

export function deleteStockJournal(id) {
    return axios.delete(`${STOCK_JOURNAL}/stock-journal/${id}`, { headers: headers() })
}

export function postStockJournal(id, requestId) {
    return axios.post(`${STOCK_JOURNAL}/stock-journal/${id}/post`, {}, { headers: {...headers(), "X-Request-ID": requestId} })
}

export function getDrafts(type) {
    return axios.get(`${STOCK_JOURNAL}/stock-journal-draft`, { headers: headers(), params: { type } });
}